// extracted by mini-css-extract-plugin
export var askAiIcon = "_m0-9";
export var container = "_m0-0";
export var groupSeparator = "_m0-a";
export var highlight = "_m0-4";
export var resultIcon = "_m0-5";
export var resultItem = "_m0-7";
export var resultSubtitle = "_m0-3";
export var resultTitle = "_m0-2";
export var resultsList = "_m0-1";
export var searchGroup = "_m0-6";
export var selected = "_m0-8";